module.exports = __webpack_public_path__ + "img/fast.5703d0b.webp";